import { useMutation } from 'react-query';
import reportTokenServices from './reportToken.services';
import notificationError from '@/utils/functions/notificationError';

export function useReportTokenGenerate() {
  return useMutation(reportTokenServices.generateToken, {
    onError(error) {
      notificationError(error);
    },
  });
}
